export const NAME_CLASSES = 'w-1/5 min-w-[10rem]';
export const NUMBER_CLASSES = 'w-[2.5rem]';
export const CATEGORY_CLASSES = 'w-[3.5rem]';
export const TIME_CLASSES = 'w-1/6  max-w-[7rem] min-w-[5rem]';
